import { Box, Paper, IconButton, useTheme } from '@mui/material';
import React, { FC, useState } from 'react';
import { farmService } from '../FarmService';
import KeyVaultConstants from '../../KeyVault/Common/Constants';
import { useFarmStyles as CommonStyle } from '../../../../Common/Styles';
import { ThemedCopyIcon } from '../../../../Common/Components/Icons';
import { showToast } from '../../../../lib/toast';

const DetailsHolder: FC<{ farmId: number }> = ({ farmId }) => {
  const { classes: commonClass } = CommonStyle();
  const theme = useTheme();
  const [loading, setLoading] = useState(0);
  const userName = `farm${farmId}Admin`;

  const toastforSecretCopy = () =>
    showToast({
      type: 'success',
      title: KeyVaultConstants.SecretCoppied,
    });

  const loadAdminPassword = async () => {
    try {
      setLoading(loading + 1);
      const password = await farmService.getPassword(farmId);
      try {
        await navigator.clipboard.writeText(password);
        toastforSecretCopy();
      } catch (clipboardError) {
        showToast({
          type: 'error',
          title: 'Failed to copy password to clipboard.',
        });
        console.log(clipboardError);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(loading - 1);
    }
  };

  const copyUserName = () => {
    navigator.clipboard.writeText(userName);
    toastforSecretCopy();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: theme.palette.background.paper,
        padding: '10px 12px',
        color: theme.palette.text.primary,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span className={commonClass.span}>Username</span>
          <Box
            component="span"
            className={commonClass.span}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            {userName}
            <IconButton onClick={copyUserName} sx={{ ml: 1 }}>
              <ThemedCopyIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span className={commonClass.span}>VM Password</span>
          <Box
            component="span"
            className={commonClass.span}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            xxxxxxxxxxxx
            <IconButton onClick={loadAdminPassword} sx={{ ml: 1 }}>
              <ThemedCopyIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default DetailsHolder;
